"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getAppealPreview = exports.getAppealCard = void 0;
const adaptivecards_1 = require("adaptivecards");
const cards_1 = require("../../agile/cards");
const cards_2 = require("../../survey/cards");
const components_1 = require("../components");
const appealsHelperUtils_1 = require("./appealsHelperUtils");
const CardHelper_1 = require("./CardHelper");
const getAppealCard = (survey, options) => {
    switch (survey.type) {
        case "poll":
            return (0, cards_2.SurveyPollAppealCard)(survey, options);
        case "agile-standup":
            return (0, cards_1.agileStandupAppealCard)(survey, options);
        case "survey":
            return (0, cards_2.SurveyAppealCard)(survey, options);
        case "trivia":
            return (0, cards_2.TriviaAppealCard)(survey);
        case "quiz":
            return (0, cards_2.QuizAppealCard)(survey, options);
        case "qna":
            return (0, cards_2.QnaAppealCard)(survey);
        case "icebreaker":
            return (0, cards_2.IcebreakerAppealCard)(survey, options);
        case "hot-take":
            return (0, cards_2.HotTakeAppealCard)(survey, options);
        default:
            throw `unknown survey type to create appeal card: ${survey.type}`;
    }
};
exports.getAppealCard = getAppealCard;
const getAppealPreview = (draft, owner, tenantId, applicationType, options) => {
    var _a, _b;
    const survey = Object.assign(Object.assign(Object.assign({}, draft), { 
        // Validation guarantees recipients are not null but compiler doesn't know
        // This hack convinces the compiler recipients in `survey` won't be null
        recipients: draft.recipients || [], deliverAt: draft.schedule
            ? (0, appealsHelperUtils_1.getUserDateAsUTC)(draft.schedule.rruleDTStart, draft.schedule.rruleTZID)
            : draft.deliverAt || new Date(), id: (_a = draft.id) !== null && _a !== void 0 ? _a : "", tenantId,
        applicationType, createdAt: new Date(), updatedAt: new Date(), owners: [owner], responseCount: 0, state: "open", reminders: (0, appealsHelperUtils_1.getSurveyFilteredReminders)(draft.reminders) }), (draft.closeAt && {
        closeAt: draft.closeAt,
    }));
    const frequencyDisplayText = draft.schedule
        ? (0, appealsHelperUtils_1.rruleToFrequencyString)(draft.schedule.rrule)
        : undefined;
    const appeal = (0, exports.getAppealCard)(survey, Object.assign(Object.assign({ hideDetailsBar: options === null || options === void 0 ? void 0 : options.hideDetailsBar }, ((options === null || options === void 0 ? void 0 : options.detailsJoinString) && { detailsJoinString: options.detailsJoinString })), ((options === null || options === void 0 ? void 0 : options.hideAllResultsButton) && { hideAllResultsButton: options.hideAllResultsButton })));
    const addQuestions = (_b = options === null || options === void 0 ? void 0 : options.addQuestions) !== null && _b !== void 0 ? _b : true;
    if (survey.type === "survey" && addQuestions) {
        survey.questions.forEach((question, index) => {
            appeal.addItem((0, components_1.questionTakingContainer)(question, index + 1, {
                highlightRequired: true,
            }));
        });
    }
    if (!frequencyDisplayText) {
        return appeal;
    }
    const frequencyContainer = CardHelper_1.CardHelper.create(adaptivecards_1.Container, {
        style: adaptivecards_1.ContainerStyle.Emphasis,
        spacing: adaptivecards_1.Spacing.Large,
    });
    frequencyContainer.addItem(CardHelper_1.CardHelper.create(adaptivecards_1.FactSet, {
        facts: [
            new adaptivecards_1.Fact("📅", `Scheduled to be sent ${frequencyDisplayText} starting ${CardHelper_1.CardHelper.dateReplacementString(survey.deliverAt, "COMPACT")} at ${CardHelper_1.CardHelper.timeReplacementString(survey.deliverAt)}`),
        ],
    }));
    const firstItem = appeal.getItemAt(0);
    firstItem.spacing = adaptivecards_1.Spacing.Large;
    firstItem.separator = true;
    appeal.insertItemBefore(frequencyContainer, firstItem);
    return appeal;
};
exports.getAppealPreview = getAppealPreview;
__exportStar(require("./appealsHelperUtils"), exports);
//# sourceMappingURL=appealsHelper.js.map